package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import io.horion.cv.models.Theme
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val LogoStyle = CssStyle {
    base {
        Modifier
            .height(32.px)
            .transform { rotate(0.deg) }
            .transition {
                property("transform")
                duration(200.ms)
            }
    }
    hover {
        Modifier
            .transform { rotate((-10).deg) }
    }
    // À partir de LG
    Breakpoint.LG {
        Modifier.height(40.px)
    }
}

val NavigationItemStyle = CssStyle {
    base {
        Modifier
            .color(Theme.LightBlack.rgb)
            .transition {
                property("color")
                duration(200.ms)
            }
    }

}

val AlignmentOptionStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(com.varabyte.kobweb.compose.ui.graphics.Colors.Transparent)
            .styleModifier { property("transition", "background-color 150ms ease") }
    }
    hover {
        Modifier.backgroundColor(
            if (colorMode.isDark) Colors.holder else Colors.White
        )
    }
}

val ButtonStyle = CssStyle {
    base {
        Modifier
            .color(Colors.Blue)
            .backgroundColor(Colors.White)
    }
    hover {
        Modifier
            .color(Colors.White)
            .backgroundColor(Colors.button)
    }
}

val CreateButtonStyle = CssStyle {
    base {
        Modifier
            .backgroundImage(
                gradient = linearGradient(
                    from = Colors.DarkBlue,
                    to = Colors.linear,
                    dir = LinearGradient.Direction.ToRight
                )
            )

    }
}

val ConnectButtonStyle = CssStyle {
    base {
        Modifier
            .background(Colors.LighterBlue)
            .transition {
                property("button")
                duration(250.ms)
            }
    }
    hover {
        Modifier
            .backgroundColor(Colors.LighterBlue.lightened(0.3f))
    }
}

val connectStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.Blue)
            .transition {
                property("button")
                duration(250.ms)
            }
    }
    hover {
        Modifier
            .backgroundColor(Colors.Blue.lightened(0.3f))
    }
}


val ProfileFormStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(
                if (colorMode.isDark) {
                    Colors.input
                } else {
                    Colors.LightGray
                }
            )
            .border(0.px)
            .borderRadius(5.px)
            .fontSize(16.px)
            .color(Colors.Black)
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
                property("max-width", "100%")
            }
            .transition {
                property("border-color")
                duration(200.ms)
            }
    }
}

val RichTextLabelStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Light)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(16.px)
    }
}

val GoogleStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White)
            .transition {
                duration(450.ms)
                timingFunction(TransitionTimingFunction.cubicBezier(0.2, 1.20, 0.2, 1.0))
            }
    }
    hover {
        Modifier
            .backgroundColor(Colors.LighterBlue.copy(alpha = 30))
    }
}

val AppleStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White)
            .transition {
                duration(450.ms)
                timingFunction(TransitionTimingFunction.cubicBezier(0.2, 1.20, 0.2, 1.0))
            }
    }
    hover {
        Modifier
            .backgroundColor(Colors.gray.copy(alpha = 30))
    }
}

val GlobalBackgroundStyle = CssStyle {
    Modifier
        .backgroundColor(Colors.DarkBG)
}

val ModifyButtonStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.Placeholder.darkened(0.2f))
            .transition {
                property("background-color")
                duration(200.ms)
            }
    }
    hover {
        Modifier
            .backgroundColor(Colors.Placeholder)
    }
}

val DownloadButtonStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.BlueLight)
            .transition {
                property("background-color")
                duration(200.ms)
            }
    }
    hover {
        Modifier
        .backgroundColor(Colors.BlueLight.darkened(0.2f))
    }
}

val PoliceStyle = CssStyle {
    base {
        Modifier
            .border(1.px, LineStyle.Solid, Colors.White)

    }
    hover {
        Modifier
            .border(1.px, LineStyle.Solid, Colors.blue)
    }
}

val SearchButtonStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.Blue)
            .transition {
                property("background-color")
                duration(200.ms)
            }
    }
    hover {
        Modifier
            .backgroundColor(Colors.Blue.lightened(0.15f))
    }
}


val DeleteStyle = CssStyle {
    base {
        Modifier
            .border(1.px, LineStyle.Solid, Colors.White)
    }
    hover {
        Modifier
            .border(1.px, LineStyle.Solid, Colors.blue)
    }
}

val SubscribeButtonStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.Blue.lightened(0.2f))
            .transition {
                property("all")
                duration(250.ms)
                timingFunction(AnimationTimingFunction.EaseInOut)
            }
    }
    hover {
        Modifier
            .scale(1.05)
            .backgroundColor(Colors.NightBlue)
    }
}

val validatebuttonStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.DarkGray)
            .transition {
                property("all")
                duration(250.ms)
                timingFunction(AnimationTimingFunction.EaseInOut)
            }
    }
    hover {
        Modifier
            .scale(1.05)
            .backgroundColor(Colors.NightBlue)
    }
}